import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { compact } from 'lodash-es';
import { DropdownMenu, TableList, TableListActions, Typography } from 'seagull';
import { CopyFill, TrashLine } from 'seagull/icons';
import { useLocaleKeys } from '~/i18n';
import { serviceTemplateModel } from '~/models';
import { Accounting } from '~/types/api.model';
import { billingTriggerLabel, ColumnId, occurrenceLabel, occurrenceTextsPath, triggerLabelsTextsPath } from './CommonServicesPage.utils';
import styles from './RowItem.module.scss';
import { ServiceRowName } from './ServiceRowName';
import { ServiceRowPrice } from './ServiceRowPrice/ServiceRowPrice';
export function RowItem(param) {
    let { service: initialService, qboItemsById, xeroItemsById, serviceNameValidation, onInlineEdit: onInlineEditProp, onEdit, onDuplicate, onDelete, onInputFocus, onInputBlur, columns, isHeightFluid } = param;
    const [service, setService] = useState(initialService);
    const { t: occurrenceTexts } = useLocaleKeys(occurrenceTextsPath);
    const { t: triggerLabelsTexts } = useLocaleKeys(triggerLabelsTextsPath);
    const qboIntegratedId = serviceTemplateModel.integratedId({
        serviceTemplate: service,
        accounting: Accounting.QBO
    });
    const xeroIntegratedId = serviceTemplateModel.integratedId({
        serviceTemplate: service,
        accounting: Accounting.Xero
    });
    useEffect(()=>{
        setService(initialService);
    }, [
        initialService
    ]);
    const onInlineEdit = useCallback((edit)=>{
        const newService = _object_spread({}, service, edit);
        onInlineEditProp(newService);
        setService(newService);
    }, [
        service,
        onInlineEditProp
    ]);
    function nameColumn() {
        var _qboItemsById_qboIntegratedId, _xeroItemsById_xeroIntegratedId;
        return /*#__PURE__*/ _jsx(ServiceRowName, {
            onInputFocus: onInputFocus,
            onInputBlur: onInputBlur,
            service: service,
            serviceNameValidation: serviceNameValidation,
            onInlineEdit: onInlineEdit,
            qboServiceDisplay: qboIntegratedId && ((_qboItemsById_qboIntegratedId = qboItemsById[qboIntegratedId]) === null || _qboItemsById_qboIntegratedId === void 0 ? void 0 : _qboItemsById_qboIntegratedId.name),
            xeroServiceDisplay: xeroIntegratedId && ((_xeroItemsById_xeroIntegratedId = xeroItemsById[xeroIntegratedId]) === null || _xeroItemsById_xeroIntegratedId === void 0 ? void 0 : _xeroItemsById_xeroIntegratedId.name)
        });
    }
    function occurenceColumn() {
        return /*#__PURE__*/ _jsx(Typography, {
            skin: "secondary",
            children: occurrenceLabel(service.billing, occurrenceTexts)
        });
    }
    function billingColumn() {
        return /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            skin: "secondary",
            children: billingTriggerLabel(service.billing, triggerLabelsTexts)
        });
    }
    function includedServicesColumn() {
        var _service_bundle;
        return /*#__PURE__*/ _jsx(Typography, {
            skin: "secondary",
            testId: "service-library-row-included-services",
            children: /*#__PURE__*/ _jsx("ul", {
                className: styles.includedServices,
                children: (_service_bundle = service.bundle) === null || _service_bundle === void 0 ? void 0 : _service_bundle.services.map((param, index)=>{
                    let { name } = param;
                    return /*#__PURE__*/ _jsx("li", {
                        children: name
                    }, "".concat(service.id, "-").concat(index));
                })
            })
        });
    }
    function rateColumn() {
        return /*#__PURE__*/ _jsx(ServiceRowPrice, {
            service: service,
            onInlineEdit: onInlineEdit,
            onInputFocus: onInputFocus,
            onInputBlur: onInputBlur
        });
    }
    function getColumnItems() {
        const columnsMap = {
            [ColumnId.Name]: nameColumn,
            [ColumnId.Rate]: rateColumn,
            [ColumnId.BillingOccurance]: occurenceColumn,
            [ColumnId.BillingTrigger]: billingColumn,
            [ColumnId.IncludedServices]: includedServicesColumn
        };
        return compact(columns.map((column)=>({
                value: columnsMap[column]()
            })));
    }
    return /*#__PURE__*/ _jsx(TableList.Row, {
        testId: "service-library-row",
        rowId: service.id,
        size: isHeightFluid ? 'fluid' : 'medium',
        actionColumn: /*#__PURE__*/ _jsxs(TableListActions, {
            buttonText: "Edit",
            testId: "service-library-row-actions",
            onClickButton: onEdit,
            children: [
                /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                    iconStart: /*#__PURE__*/ _jsx(CopyFill, {}),
                    testId: "service-library-row-duplicate",
                    onClick: onDuplicate,
                    children: "Duplicate"
                }),
                /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                    skin: "error",
                    iconStart: /*#__PURE__*/ _jsx(TrashLine, {}),
                    testId: "service-library-row-delete",
                    onClick: onDelete,
                    children: "Delete"
                })
            ]
        }),
        items: getColumnItems()
    });
}
